let locationRegionOptions = document?.getElementById("region-oms-location");
let locationComunaOptions = document?.getElementById("comuna-oms-location");

let storeRegionOptions = document?.getElementById("region-oms-store");
let storeComunaOptions = document?.getElementById("comuna-oms-store");

let chilexpressRegionOptions = document?.getElementById(
  "region-oms-chilexpress"
);
let chilexpressComunaOptions = document?.getElementById(
  "comuna-oms-chilexpress"
);

let storesFiltered = [];
let chilexpressFiltered = [];

let regions = [];
let cities = [];

let citiesLocationTemp = [];
let citiesStorageTemp = [];
let citiesChilexpressTemp = [];

let shopifyProductsCartItems = [];

let regionSequence = [
  { name: "Santiago", sequence: 0 },
  { name: "Biobío", sequence: 1 },
  { name: "La Araucanía", sequence: 2 },
  { name: "Los Lagos", sequence: 3 },
  { name: "Aysén", sequence: 4 },
];

let regionSequenceChilexpress = [
  { name: "Arica y Parinacota", sequence: 0 },
  { name: "Tarapacá", sequence: 1 },
  { name: "Antofagasta", sequence: 2 },
  { name: "Atacama", sequence: 3 },
  { name: "Coquimbo", sequence: 4 },
  { name: "Valparaíso", sequence: 5 },
  { name: "Santiago", sequence: 6 },
  { name: "Ohiggins", sequence: 7 },
  { name: "Maule", sequence: 8 },
  { name: "Ñuble", sequence: 9 },
  { name: "Biobío", sequence: 10 },
  { name: "La Araucanía", sequence: 11 },
  { name: "Los Ríos", sequence: 12 },
  { name: "Los Lagos", sequence: 13 },
  { name: "Aysén", sequence: 14 },
  { name: "Magallanes y Antártica", sequence: 15 },
];

const getShopifyProductsCart = async () => {
  const response = await $.ajax({
    cache: false,
    url: "/cart.json",
    type: "get",
    dataType: "json",
  });

  shopifyProductsCartItems = response.items;
};

const clearSelectedOptions = (modalType) => {
  if (modalType === "location" && locationComunaOptions !== null)
    locationComunaOptions.innerHTML = "";
  if (modalType === "store") storeComunaOptions.innerHTML = "";
  if (modalType === "chilexpress") chilexpressComunaOptions.innerHTML = "";
};

const loadCartItem = async () =>
  await $.ajax({
    cache: false,
    url: "/cart.json",
    type: "get",
    dataType: "json",
  });
  
const updateCartShippingMethod = async (
  id,
  quantity,
  shippingMethod = null,
  reloadPage = true
) => {
  const cart = await loadCartItem();
  const shopifyProducts = cart?.items || [];
  const itemIdUpdate = shopifyProducts.find((item) => item.variant_id === id);
  const itemExistsInCart = shopifyProducts.find(
    (item) =>
      item.id === itemIdUpdate.id &&
      item.key !== itemIdUpdate.key &&
      item.properties.shippingMethod.store_type === shippingMethod
  );

  if (itemExistsInCart) {
    const itemDelete = {
      id: itemExistsInCart.key,
      quantity: 0,
    };
    try {
      const response = await axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: `cart/change.js`,
        data: itemDelete,
      });
      // if (reloadPage) location.reload();
    } catch (error) {
      console.error(`Error: ${error.message}`);
    }
  }

  const item = {
    id: itemIdUpdate.key,
    quantity: (itemExistsInCart?.quantity ?? 0) + itemIdUpdate.quantity,
    properties: {
      shippingMethod: {
        store_type: shippingMethod || null,
        ...(shippingMethod === "Tienda" && {
          store: localStorage.getItem("stores"),
        }),
      },
    },
  };

  try {
    const response = await axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: `cart/change.js`,
      data: item,
    });
    if (reloadPage || itemExistsInCart) location.reload();
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
};

const searchRegionBySelection = (shopify_code) => {
  if (shopify_code) {
    const _result = stores.filter(
      (store) => store.state.shopify_code === shopify_code
    );
    renderStores(_result);
  }
};

const searchChilexpressRegionBySelection = (code) => {
  if (code) {
    const _result = storesChilexpress.filter(
      (store) => store.state.code === code
    );
    renderStoresChile(_result);
  }
};

const getRegionsOms = async (urlParam) => {
  const url =
    urlParam !== null
      ? `${baseUrlOMS}/api/v1/state/?${urlParam}=true`
      : `${baseUrlOMS}/api/v1/state/`;

  await axios
    .get(`${url}`, {
      responseType: "json",
      Headers: { "Access-Control-Allow-Origin": "*" },
    })
    .then(async function (res) {
      if (res.status == 200) {
        let regionsResponse = res.data.states;
        if (urlParam === null) {
          localStorage.setItem("regions-oms", JSON.stringify(regionsResponse));
        }

        $("#region-oms-location option:not(:first)").remove();
        $("#region-oms-store option:not(:first)").remove();
        $("#region-oms-chilexpress option:not(:first)").remove();

        if (urlParam === "store") {
          regionsResponse.forEach((state, index) => {
            const matchingRegion = regionSequence.find(
              (region) => region.name === state.name
            );
            state.sequence = matchingRegion
              ? matchingRegion.sequence
              : index + 1;
          });
          regionsResponse = regionsResponse.sort(
            (a, b) => a.sequence - b.sequence
          );
        }

        if (urlParam === "is_branch") {
          regionsResponse.forEach((state, index) => {
            const matchingRegion = regionSequenceChilexpress.find(
              (region) => region.name === state.name
            );
            state.sequence = matchingRegion
              ? matchingRegion.sequence
              : index + 1;
          });
          regionsResponse = regionsResponse.sort(
            (a, b) => a.sequence - b.sequence
          );
        }

        regionsResponse.forEach((element) => {
          const option = document.createElement("option");
          option.setAttribute("data-info", JSON.stringify(element));
          option.setAttribute("data-code-shopify", element.shopify_code);
          option.value = element.shopify_code;
          option.innerText = element.name;
          option?.addEventListener("change", (e) => {
            selectedRegionOms(element, urlParam);
          });
          urlParam === null && $("#region-oms-location").append(option);
          urlParam === "store" && $("#region-oms-store").append(option);
          urlParam === "is_branch" &&
            $("#region-oms-chilexpress").append(option);
        });

        if (urlParam === null && locationStorage !== null) {
          getCityByRegionOms(
            locationStorage.state?.id ?? locationStorage.state?.code,
            "location"
          );
        }

        if (urlParam === "store" && storeStorage !== null) {
          getCityByRegionOms(storeStorage.state.id, "store", false, "store");
        }
        if (urlParam === "is_branch" && chilexpressStorage !== null) {
          getCityByRegionOms(
            chilexpressStorage.state.id,
            "chilexpress",
            false,
            "is_branch"
          );
        }
      }
    })
    .catch(function (err) {
      console.log(err);
    });
};

const getCityByRegionOms = async (
  idRegion,
  modal,
  saveCities = false,
  urlParam
) => {
  await axios
    .get(`${baseUrlOMS}/api/v1/${idRegion}/city/?${urlParam}=true`, {
      responseType: "json",
      Headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
    .then(function (res) {
      if (res.status == 200) {
        cities = res.data.cities.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
        if (modal === "chilexpress") cities.sort(compareByKey("name"));
        setOptionCities(cities, modal);

        if (!saveCities && modal === "location") {
          setStorageModalLocation();
        }

        if (!saveCities && modal === "store") {
          setStorageModalStore();
        }

        if (!saveCities && modal === "chilexpress") {
          setStorageModalChilexpress();
        }
      }
    })
    .catch(function (err) {
      console.log(err);
    });
};

const clearAddressCustomers = (idCustomer) => {
  const url = `${baseUrlOMS}/api/v1/cleaner_address/${idCustomer}`;
  axios
    .get(url, fetchConfig)
    .then((res) => {
      if (res.status === 200) {
        console.log("Direcciones eliminadas");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const compareByKey = (key) => (a, b) => a[key].localeCompare(b[key]);

const setOptionCities = (cities, modal) => {
  let wrapper;
  let comuneEl;
  if (modal === "location") {
    wrapper = document.getElementById("select-comune-location");
    comuneEl = document.getElementById("comuna-oms-location");
  } else if (modal === "store") {
    wrapper = document.getElementById("select-comune-store");
    comuneEl = document.getElementById("comuna-oms-store");
  } else {
    wrapper = document.getElementById("select-comune-chilexpress");
    comuneEl = document.getElementById("select-btn-comune-chilexpress");
  }

  /*   comuneEl.firstElementChild.innerText = "Comuna";
   */
  $("#comuna-oms-location option").remove();
  $("#comuna-oms-store option:not(:first)").remove();
  $("#comuna-oms-chilexpress option:not(:first)").remove();

  cities.forEach((element) => {
    const option = document.createElement("option");
    option.innerText = element.name;
    option.setAttribute("data-info", JSON.stringify(element));
    option.value = element.code;
    option?.addEventListener("change", (e) => {
      comuneEl.firstElementChild.innerText = element.name;
      comuneEl.setAttribute("data-info", JSON.stringify(element));
      wrapper.classList.toggle("active");
      modal === "chilexpress"
        ? changeRegionFilterChilexpress(element)
        : changeRegionFilterStore(element);
    });
    modal === "location" && locationComunaOptions?.appendChild(option);
    modal === "store" && storeComunaOptions.appendChild(option);
    modal === "chilexpress" && chilexpressComunaOptions.appendChild(option);
  });
};

const setStorageModalLocation = async () => {
  const locationStorage = await getITemLocalStorage("locations");
  if (locationStorage === null) return;
  const comuneEl = document.getElementById("comuna-oms-location");
  const regionEl = document.getElementById("region-oms-location");

  regionEl.value = locationStorage.state.shopify_code;
  comuneEl.value = locationStorage.city.code;
};

const setStorageModalStore = async () => {
  const storageStore = getITemLocalStorage("stores");
  const comuneEl = document.getElementById("comuna-oms-store");
  const regionEl = document.getElementById("region-oms-store");

  if (storageStore === null || shopifyProductsCartItems.length > 0) {
    regionEl.firstElementChild.innerText = "Region";
    comuneEl.firstElementChild.innerText = "Comuna";
    return;
  }

  regionEl.firstElementChild.innerText = storageStore.state.name;
  comuneEl.firstElementChild.innerText = storageStore.city.name;
  regionEl.setAttribute("data-info", JSON.stringify(storageStore.state));
  comuneEl.setAttribute("data-info", JSON.stringify(storageStore.city));
  changeRegionFilterStore(storageStore.city);
};

const setStorageModalChilexpress = () => {
  const chilexpressStorage = getITemLocalStorage("branch");
  if (chilexpressStorage === null) return;
  const comuneEl = document.getElementById("comuna-oms-chilexpress");
  const regionEl = document.getElementById("region-oms-chilexpress");
  regionEl.firstElementChild.innerText = chilexpressStorage.state.name;
  comuneEl.firstElementChild.innerText = chilexpressStorage.city.name;
  regionEl.setAttribute("data-info", JSON.stringify(chilexpressStorage.state));
  comuneEl.setAttribute("data-info", JSON.stringify(chilexpressStorage.city));
  changeRegionFilterChilexpress(chilexpressStorage.city);
};

const selectedRegionOms = (option, urlParam) => {
  const idRegion = option?.id ?? option?.code;
  if (urlParam === null) {
    return getCityByRegionOms(idRegion, "location", true);
  }

  if (urlParam === "store") {
    searchRegionBySelection(option.shopify_code);
    return getCityByRegionOms(idRegion, urlParam, true, urlParam);
  }

  if (urlParam === "is_branch") {
    searchChilexpressRegionBySelection(option.code);
    return getCityByRegionOms(idRegion, "chilexpress", true, urlParam);
  }
};

const changeRegionFilterStore = (option) => {
  const result = stores.filter((item) => {
    return item.city.code === option?.code;
  });

  storesFiltered = result;
  renderStores(storesFiltered);
};

const changeRegionFilterChilexpress = (option) => {
  const result = storesChilexpress.filter((item) => {
    return item.city.code === option?.code;
  });
  chilexpressFiltered = result;
  renderStoresChile(chilexpressFiltered);
};

const setITemLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const getITemLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

const compute = async (data) => {
  const body = {
    cart_id: data.cart_id,
    subtotal: data.subtotal,
    currency: data.currency,
    shipping_address: data.shipping_address,
    lines: data.lines,
    deliveries: data.deliveries,
  };

  const response = await axios.post(
    `${baseUrlOMS}/api/v1/compute/`,
    body,
    fetchConfig
  );
  return response?.data;
};

function getDayOfWeek(dateString) {
  if (!dateString) return "";
  const [day, month, year] = dateString.split("/");
  const date = new Date(`${year}-${month}-${day}`);
  const daysOfWeek = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  const dayName = daysOfWeek[date.getUTCDay()];

  return dayName;
}

const convertDate = (date) => {
  if (!date) return "";
  const options = { month: "long", day: "numeric" };
  const date_array = date.split("/");

  const day = Number(date_array[0]);
  const month = Number(date_array[1]) - 1;
  const year = Number(date_array[2]);

  const new_date = new Date(year, month, day);
  return new_date.toLocaleDateString("es-ES", options);
};

function immediateShipping(dateString) {
  if (!dateString) return false;
  const parseDate = (str) => {
    const [day, month, year] = str?.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  const fechaActual = new Date();
  const fechaPedido = parseDate(dateString);
  return fechaPedido.toDateString() === fechaActual.toDateString();
}

let locationStorage = getITemLocalStorage("locations");
let storeStorage = getITemLocalStorage("stores");
let chilexpressStorage = getITemLocalStorage("branch");

const setUtilsLocationStorage = (newStorage) => (locationStorage = newStorage);
const setUtilsStoreStorage = (newStorage) => (storeStorage = newStorage);
const setUtilsChilexpressStorage = (newStorage) =>
  (chilexpressStorage = newStorage);

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

  const formatter = new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP'
        });

const stopLoaderSelect = () => {
    document.querySelectorAll('input[type="radio"][name="shipping-method-option"]').forEach((radio) => {radio.disabled = false;});
    $(".shipping-section-loader").addClass("d-none");
    $("#grouped-products").removeClass("d-none");
    $("#go-to-checkout").removeClass("disable");
    $("#go-to-checkout").removeAttr("disabled");
}

const openLoaderSelect = () => {
    document.querySelectorAll('input[type="radio"][name="shipping-method-option"]').forEach((radio) => {radio.disabled = true;});
    $("#grouped-products").addClass("d-none");
    $("#go-to-checkout").addClass("disable");
    $("#go-to-checkout").attr("disabled", true);

    $(".shipping-section-loader").removeClass("d-none");
}

getShopifyProductsCart();
